import {redirect} from 'react-router-dom';
import AuthProvider from '../hooks/authProvider';
import {canAccessRoute} from './permissions';

export async function requireAuthenticated({request}) {
    if (!(await AuthProvider.checkAuth())) return redirect(`/login?from=${encodeURIComponent(new URL(request.url).pathname)}`);
    const user = await AuthProvider.getUserDetails();
    if (!user) return redirect(`/login?from=${encodeURIComponent(new URL(request.url).pathname)}`);
    return user;
}

export async function requirePartnerOrSuperAdmin({request}) {
    const user = await requireAuthenticated({request});
    if (user instanceof Response) return user;
    if (!canAccessRoute(user, 'partner')) return redirect('/');
    return user;
}

export async function requireSuperAdmin({request}) {
    const user = await requireAuthenticated({request});
    if (user instanceof Response) return user;
    if (!canAccessRoute(user, 'superadmin')) return redirect('/forbidden');
    return user;
}